// Central registry of verified DoctorLab photos (real, not stock).
// Descriptions come from the uploader. Alt text is written for SEO.

export const PHOTOS = {
  storefront: {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/mxil9l4o_DOCTORLAB%20AND%20DIAGNOSTICS%20COLLECTION%20TESTING%20LAB%20RANCHI.jpeg",
    alt: "DoctorLab & Diagnostics storefront signboard – pathology lab in Lalpur, Ranchi",
    filename: "doctorlab-diagnostics-storefront-ranchi.jpg",
  },
  reception: {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/ulpefsfg_INHOUSE%20SAMPLE%20PROCESSING%20AND%20BLOOD%20COLLECTION%20IN%20RANCHI.jpeg",
    alt: "DoctorLab reception desk – blood sample collection in Ranchi",
    filename: "doctorlab-reception-ranchi.jpg",
  },
  machine: {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/1w5vs6i2_ADVANCED%20HIGHTECH%20MACHINE%20DOCTORLAB%20AUTOMATED%20SYSTEMS.jpeg",
    alt: "Automated biochemistry analyser at DoctorLab & Diagnostics laboratory in Ranchi",
    filename: "doctorlab-automated-analyser-ranchi.jpg",
  },
  justdialBadge: {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/my3rtuqx_AMITABH%20BACCHAN%20ENDORSING%20DOCTORLAB%20AND%20DIAGNOSTICS%20JUSTDIAL%20JD.jpeg",
    alt: "JustDial Users' Choice 2026 badge – DoctorLab & Diagnostics, Ranchi",
    filename: "doctorlab-justdial-users-choice-2026.jpg",
  },
  logo: {
    src: "https://customer-assets-v7afamib.emergentagent.net/job_premium-lab-tests/artifacts/lk9a1hdz_logo_basic%20%281%29.webp",
    alt: "DoctorLab & Diagnostics logo",
    filename: "doctorlab-diagnostics-logo.webp",
  },
};

export default PHOTOS;
